import { useState, useRef } from 'react';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import CreateTeamModal from './create_team_modal.component';
import { TeamManagementTable } from './TeamManagementTable';
import styles from './team_management.module.css';

import { createNewTeam } from './functions/create_new_team.function';
import { updateTeam } from './functions/update_team.function';
import { notify } from '../../common/functions/react-toastify.function';

const TeamManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [selectedTeam, setSelectedTeam] = useState(null);
  const tableRef = useRef(null);

  const handleCreateTeam = () => {
    setSelectedTeam(null);
    setModalMode('create');
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTeam(null);
  };

  const handleEditTeam = (team) => {
    setSelectedTeam(team);
    setModalMode('edit');
    setIsModalOpen(true);
  };

  const handleSubmit = async (teamData) => {
    if (modalMode === 'create') {
      const result = await createNewTeam(teamData);

      if (result.success) {
        const successMessage = result?.data?.message || 'Team created successfully';
        notify('success', successMessage);
        // Refetch teams data to show updated table
        if (tableRef.current) {
          tableRef.current.refetchTeams();
        }
        return { success: true };
      } else {
        return { success: false };
      }
    } else {
      const result = await updateTeam(teamData);

      if (result.success) {
        const successMessage = result?.data?.message || 'Team updated successfully';
        notify('success', successMessage);
        // Refetch teams data to show updated table
        if (tableRef.current) {
          tableRef.current.refetchTeams();
        }
        return { success: true };
      } else {
        return { success: false };
      }
    }
  };

  return (
    <div className={styles['team-management-container']}>
      <div className={styles['team-management-header']}>
        <div className={styles['header-left']}>
          <div className={styles['back-icon-container']}>
            <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
          </div>
          <h1 className={styles['page-title']}>Team Management</h1>
        </div>
        <button className={styles['create-team-btn']} onClick={handleCreateTeam}>
          Create Team
        </button>
      </div>

      {/* Content area for team management functionality */}
      {/* <div>
        <p>Team management functionality will be implemented here.</p>
      </div> */}
      <TeamManagementTable
        ref={tableRef}
        onEdit={handleEditTeam}
        onDeleteSuccess={() => {
          // Optional: Add any additional logic after successful deletion
          console.log('Team deleted successfully');
        }}
      />

      {/* Create Team Modal */}
      <CreateTeamModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        mode={modalMode}
        initialData={selectedTeam}
        title={modalMode === 'create' ? 'Create New Team' : 'Edit Team'}
        buttonText={modalMode === 'create' ? 'Create' : 'Update'}
      />
    </div>
  );
};

export default TeamManagement;
